module.exports = __webpack_public_path__ + "img/icon_search.c0a9fbc5.svg";